/**
 * Company identities printed on exported reports (PDF letterhead + footer,
 * XLSX letterhead). Travel and Trading are the same legal group but print a
 * division-specific name; address/contact are shared.
 */
export interface ReportCompany {
  name: string;
  address: string;
  phone: string;
  email: string;
  web: string;
  /** Public-path URL of the division logo printed on PDF letterheads. */
  logo?: string;
}

export const TRAVEL_COMPANY: ReportCompany = {
  name: 'POLATKAN TURİZM',
  address: 'Gazeteci Kemal Togan Sk, Lefkoşa 99010',
  phone: '(0392) 444 02 22',
  email: 'info@polatkanturizm.com',
  web: 'www.polatkan.net',
  logo: '/polatkan-logo.png',
};

export const TRADING_COMPANY: ReportCompany = {
  name: 'POLATKAN TRADING',
  address: 'Gazeteci Kemal Togan Sk, Lefkoşa 99010',
  phone: '(0392) 444 02 22',
  email: 'info@polatkanturizm.com',
  web: 'www.polatkan.net',
  logo: '/polatkan-trading-logo.png',
};
